/* ============================================
   Senchado 2.0 — ブログ一覧 v2 モーションエンジン
   出典: prototype/blog-mockup.html <script>（IO発火条件がベース）
   セクション: sections/senchado-main-blog.liquid（defer 読込）

   責務:
     スクロール連動モーション。ビューポート中央帯（上下 -40%）に入った
     カードへ .is-focus を付与し、ズーム／2枚目クロスフェードを CSS 側で分岐。
     - ズーム: 帯にいる間ずっと .is-focus（従来どおり・強弱2種は CSS）。
     - クロスフェード: 帯に入ったら「ピーク（チラ見せ）」＝1回だけ2枚目へ切替え、
       約1.2秒滞留したら .is-focus を外して自動的に1枚目（アイキャッチ）へ戻す。
       帯を出れば再アーム、再度入れば再び1回だけピークする。
     PC ホバーも同じピーク挙動（hover し続けても1.2秒で1枚目へ戻る）。
       ※ズームの hover は CSS が担当。クロスフェードの hover は本 JS が is-focus で駆動。
     prefers-reduced-motion では一切発火しない（即時表示のまま）。
   ============================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  // クロスフェードの滞留時間。is-focus 付与からこの時間後に外して1枚目へ戻す。
  // 行き/戻りの見た目は CSS の opacity 0.6s トランジションが担当（＝行き0.6s・滞留1.2s・戻り0.6s）。
  var PEEK_MS = 1200;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  // クロスフェードカードごとの滞留タイマー（card -> timeout id）。
  // WeakMap なのでセクション再描画で捨てられた card は自動 GC（タイマー参照リークなし）。
  var peekTimers = new WeakMap();

  function isCrossfade(card) {
    return card.getAttribute('data-motion') === 'crossfade';
  }

  // ピーク開始: 2枚目へ（is-focus 付与）。既に滞留中なら二重起動しない（行き→戻りを乱さない）。
  // PEEK_MS 後に is-focus を外して1枚目へ戻す（帯内・hover 継続中でも戻る＝チラ見せ）。
  function peekStart(card) {
    if (peekTimers.get(card) != null) return;
    card.classList.add('is-focus');
    var t = setTimeout(function () {
      peekTimers.delete(card);
      card.classList.remove('is-focus');
    }, PEEK_MS);
    peekTimers.set(card, t);
  }

  // ピーク終了/リセット: 帯を出た・hover を離れた時。走行中タイマーを clear してリーク防止＋再アーム。
  function peekStop(card) {
    var t = peekTimers.get(card);
    if (t != null) {
      clearTimeout(t);
      peekTimers.delete(card);
    }
    card.classList.remove('is-focus');
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var card = entry.target;
      if (isCrossfade(card)) {
        if (entry.isIntersecting) {
          peekStart(card);   // 中央帯に入ったら1回だけピーク（滞留後に戻る）
        } else {
          peekStop(card);    // 帯を出たらリセット（再アーム）
        }
      } else {
        // ズーム: 帯にいる間ずっと is-focus（従来どおり）
        if (entry.isIntersecting) {
          card.classList.add('is-focus');
        } else {
          card.classList.remove('is-focus');
        }
      }
    });
  }, {
    root: null,
    rootMargin: '-40% 0px -40% 0px',   // ビューポート中央帯を定義（「変わる区間」を短く）
    threshold: 0
  });

  // クロスフェードカードの PC hover を is-focus のピークで駆動（hover でも 1.2s で戻す）。
  // hover 非対応端末（タッチ）には付けない＝IO のみで駆動。二重バインドは data-* ガード。
  function bindHover(card) {
    card.addEventListener('mouseenter', function () { peekStart(card); });
    card.addEventListener('mouseleave', function () { peekStop(card); });
  }

  // 指定スコープ内の .scb-card を監視対象へ。
  // 単一の共有 observer を使い回すため、同一要素の再 observe は no-op（多重生成なし）。
  function observe(root) {
    (root || document).querySelectorAll('.scb-card').forEach(function (card) {
      io.observe(card);
      if (canHover && isCrossfade(card) && card.dataset.scbHoverBound !== '1') {
        card.dataset.scbHoverBound = '1';
        bindHover(card);
      }
    });
  }

  observe(document);

  // Theme Editor（セクション再描画）対応: 再描画された .scb-card を監視し直す。
  // senchado-home.js / senchado-sekki.js と同じ shopify:section:load 慣行に揃える
  // （これがないとカスタマイザで設定変更するたびモーションがプレビューで死ぬ）。
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
